import React, { useContext } from 'react';

const StoryContext = React.createContext({});

export default function useStoryContext() {
  return useContext(StoryContext);
}

export { StoryContext };



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useStoryContext.js